"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _peractoConfig = require("@peracto/peracto-config");

var _peractoAuth = require("@peracto/peracto-auth");

var _PeractoInner = _interopRequireDefault(require("./PeractoInner"));

var _onLogin = _interopRequireDefault(require("../../handlers/on-login"));

var _onLogout = _interopRequireDefault(require("../../handlers/on-logout"));

var _theme = _interopRequireWildcard(require("../../theme"));

var _client = require("@peracto/client");

var _onApiError = _interopRequireDefault(require("../../handlers/on-api-error"));

var _reactToastify = require("react-toastify");

require("react-toastify/dist/ReactToastify.css");

var _excluded = ["config", "onApiError", "onLogin", "onLogout", "inner"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

_reactToastify.toast.configure({
  position: 'top-right',
  className: 'toast-container',
  autoClose: 5000,
  newestOnTop: true,
  pauseOnHover: false
});

var Peracto = function Peracto(_ref) {
  var config = _ref.config,
      _ref$onApiError = _ref.onApiError,
      onApiError = _ref$onApiError === void 0 ? _onApiError["default"] : _ref$onApiError,
      _ref$onLogin = _ref.onLogin,
      onLogin = _ref$onLogin === void 0 ? _onLogin["default"] : _ref$onLogin,
      _ref$onLogout = _ref.onLogout,
      onLogout = _ref$onLogout === void 0 ? _onLogout["default"] : _ref$onLogout,
      _ref$inner = _ref.inner,
      inner = _ref$inner === void 0 ? _PeractoInner["default"] : _ref$inner,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_peractoConfig.ConfigProvider, {
    config: config
  }, /*#__PURE__*/_react["default"].createElement(_peractoAuth.AuthProvider, {
    onLogin: onLogin,
    onLogout: onLogout
  }, /*#__PURE__*/_react["default"].createElement(_peractoAuth.AuthConsumer, null, function (_ref2) {
    var user = _ref2.user;
    return /*#__PURE__*/_react["default"].createElement(_client.ClientProvider, {
      user: user,
      entrypoint: config.get('api'),
      onApiError: onApiError
    }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: _theme["default"]
    }, /*#__PURE__*/_react["default"].createElement(_theme.GlobalStyle, null), /*#__PURE__*/_react["default"].createElement(inner, props)));
  })));
};

var _default = Peracto;
exports["default"] = _default;